import React, { useState, useEffect, useRef } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Button } from "primereact/button";
import { api } from "../../../../../../../utility/AxiosInceptor";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import AddAgentDetail from "./Dialogs/add_agent_detail";
import AddSimModelDialog from "./Dialogs/add_sim_model_dialog";
import CommonLoaderBlue from "../../../../billingModel/billingmodel_configurations/Loaders/components/Loader/LoaderBlue";

export default function EsnSimSingleUpload({ setUpdateInventory }) {
  const loginRes = localStorage.getItem("userData");
  const parseLoginRes = JSON.parse(loginRes);

  const [isLoading, setIsLoading] = useState(false);
  const [addsim_Model_dialog_visibility, setAddSimModelDialogVisbility] =
    useState(false);
  const [add_agent_detail_dialog_visibility, setAddAgentDialogVisbility] =
    useState(false);

  const [carrier, setCarrier] = useState(null);
  const [Model, setModel] = useState(null);
  const [agent, setAgent] = useState(null);

  let toast = useRef();

  // ---------------------------------------------------
  // Load Carriers, Models, Agents
  // ---------------------------------------------------
  useEffect(() => {
    api
      .get(`/api/web/carrier/all`)
      .then((res) => {
        const arr = res.data.data.map((c) => ({
          label: c.name,
          value: c._id,
        }));
        setCarrier(arr);
      })
      .catch(() => {});

    api
      .get(`/api/simType/all`)
      .then((res) => {
        const arr = res.data.data.map((m) => ({
          label: m.simType,
          value: m.simType,
        }));
        setModel(arr);
      })
      .catch(() => {});

    api
      .get(`/api/web/user/getAllAgents?company=${parseLoginRes.company}`)
      .then((res) => {
        const arr = res.data.data.map((a) => ({
          label: a.name,
          value: a._id,
        }));
        setAgent(arr);
      })
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ---------------------------------------------------
  // Yup Validation (SimNumber Only)
  // ---------------------------------------------------
  const formik = useFormik({
    validationSchema: Yup.object({
      SimNumber: Yup.string()
        .required("SIM Number is required")
        .matches(/^\d+$/, "Only numbers allowed")
        .min(18, "Sim Number must be at least 18 characters")
        .max(19, "Sim Number must be at most 19 characters"),
    }),
    initialValues: {
      carrier: "",
      agentType: "",
      AgentName: "",
      SimNumber: "",
      box: "",
      Model: "",
      status: "",
    },
    onSubmit: () => handleSubmit(),
  });

  // ---------------------------------------------------
  // Submit Logic (Yup handles all validation)
  // ---------------------------------------------------
  function handleSubmit() {
    setIsLoading(true);

    const cleanObj = Object.entries(formik.values).reduce((acc, [key, val]) => {
      if (val?.length !== 0) acc[key] = val;
      return acc;
    }, {});

    api
      .post(`/api/web/simInventory/add`, cleanObj)
      .then((res) => {
        toast.current.show({
          severity: "success",
          summary: "Inventory Added",
          detail: res?.data?.msg || "Successfully Added",
        });

        setTimeout(() => {
          setUpdateInventory((prev) => !prev);
        }, 500);
      })
      .catch((err) => {
        toast.current.show({
          severity: "error",
          summary: "Operation Failed",
          detail: err?.response?.data?.msg || "Failed",
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  return (
    <>
      <div className="singleupload">
        <div className="flex flex-column">
          {/* ------------------------ SIM NUMBER FIELD ONLY ------------------------ */}
          <div className="flex" style={{ gap: "1.2rem", height: "6.8rem" }}>
            <div className="calendar_field">
              <p className="field_label">ESN/SIM Number</p>
              <InputText
                keyfilter="int"
                placeholder="ESN/SIM Number"
                value={formik.values.SimNumber}
                name="SimNumber"
                onChange={(e) =>
                  formik.setFieldValue("SimNumber", e.target.value)
                }
                onBlur={formik.handleBlur}
                className="input_text"
                style={{ width: "30rem", marginTop: ".2rem" }}
              />

              {/* Yup Error Message (Same styling kept) */}
              {formik.touched.SimNumber && formik.errors.SimNumber && (
                <p className="w-15rem mt-4 ml-3" style={{ color: "red" }}>
                  {formik.errors.SimNumber}
                </p>
              )}
            </div>
          </div>

          {/* ------------------------ CARRIER & MODEL ------------------------ */}
          <div
            className="flex"
            style={{ gap: "1.2rem", height: "6.8rem", marginTop: "1.2rem" }}
          >
            <div className="calendar_field">
              <p className="field_label">Carrier</p>
              <Dropdown
                value={formik.values.carrier}
                options={carrier}
                onChange={(e) => formik.setFieldValue("carrier", e.value)}
                placeholder="Select"
                className="dropdown"
                style={{
                  marginTop: ".2rem",
                  borderColor:
                    formik.values.carrier === "" ? "#B9BBCC" : "#9C9EB6",
                }}
              />
            </div>

            <div className="calendar_field">
              <p className="field_label">SIM Model</p>
              <Dropdown
                value={formik.values.Model}
                options={Model}
                onChange={(e) => formik.setFieldValue("Model", e.value)}
                placeholder="Select"
                className="dropdown"
                style={{
                  marginTop: ".2rem",
                  borderColor:
                    formik.values.Model === "" ? "#B9BBCC" : "#9C9EB6",
                }}
              />
            </div>
          </div>

          {/* ------------------------ STATUS & BOX ------------------------ */}
          <div
            className="flex"
            style={{ gap: "1.2rem", height: "6.8rem", marginTop: "1.2rem" }}
          >
            <div className="calendar_field">
              <p className="field_label">Status</p>
              <Dropdown
                value={formik.values.status}
                options={[
                  { label: "AVAILABLE", value: "available" },
                  { label: "INUSE", value: "inUse" },
                  { label: "DEACTIVATED", value: "deactivated" },
                ]}
                onChange={(e) => formik.setFieldValue("status", e.value)}
                placeholder="Select"
                className="dropdown"
                style={{
                  marginTop: ".2rem",
                  borderColor:
                    formik.values.status === "" ? "#B9BBCC" : "#9C9EB6",
                }}
              />
            </div>

            <div className="calendar_field">
              <p className="field_label">Box No</p>
              <InputText
                placeholder="Box Number"
                type="text"
                value={formik.values.box}
                name="box"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className="input_text"
                style={{ width: "30rem", marginTop: ".2rem" }}
              />
            </div>
          </div>

          {/* ------------------------ AGENT ------------------------ */}
          <div
            className="flex"
            style={{ gap: "1.2rem", height: "6.8rem", marginTop: "1.2rem" }}
          >
            <div className="calendar_field">
              <p className="field_label">Agent Name</p>

              <Dropdown
                value={formik.values.AgentName}
                options={agent}
                onChange={(e) => formik.setFieldValue("AgentName", e.value)}
                placeholder="Select"
                className="dropdown"
                style={{ marginTop: ".2rem" }}
              />
            </div>
          </div>

          {/* ------------------------ BUTTONS ------------------------ */}
          <div
            className="flex justify-content-end"
            style={{ gap: "1.6rem", marginTop: "5.1rem" }}
          >
            <Button
              className="backbtn"
              label="Back"
              onClick={() => setUpdateInventory(false)}
            />

            <Button
              className="nextbtn"
              label={
                isLoading ? (
                  <div className="flex flex-wrap flex-row justify-content-center w-full">
                    <CommonLoaderBlue customSize={12} color="white" />
                  </div>
                ) : (
                  "Submit"
                )
              }
              onClick={() => formik.handleSubmit()}
            />
          </div>
        </div>
      </div>

      <Dialog
        visible={addsim_Model_dialog_visibility}
        onHide={() => setAddSimModelDialogVisbility((prev) => !prev)}
      >
        <AddSimModelDialog agent={"Dummy"} />
      </Dialog>

      <Dialog
        visible={add_agent_detail_dialog_visibility}
        onHide={() => setAddAgentDialogVisbility((prev) => !prev)}
      >
        <AddAgentDetail agent={"Dummy"} />
      </Dialog>

      <Toast ref={toast} />
    </>
  );
}
